import { EmployerPayrolls } from './employer-payrolls';
import { AbstractGroupedDataset } from '@entity-framework/datasets/abstract-grouped-dataset';
import { AbstractEntity } from '@entity-framework/entity-record/state/abstract-entity';

export class OrganisationPayrollsDataset extends AbstractGroupedDataset<EmployerPayrolls> {
  getChildItems(item: EmployerPayrolls): AbstractEntity[] {
    return item.payrolls;
  }
}
